export default __webpack_public_path__ + "static/media/accordionDown.d9748552.svg";